module.exports = __webpack_public_path__ + "static/logo-shadow-5f247f6ec615d3fc2390ac1aa4b90aab.png";